import { render, staticRenderFns } from "./DeferedUploadMenu.vue?vue&type=template&id=1e98dfe7&"
import script from "./DeferedUploadMenu.vue?vue&type=script&lang=js&"
export * from "./DeferedUploadMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports